import styled from 'styled-components';
import { COLOR_WHITE } from 'constants/colors';
import {
  Menu,
} from 'antd';

export const MainContainer = styled.div`
  background-color: ${COLOR_WHITE};
  min-height: 100vh;
  width: 256px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: fixed;
  left: 0;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
`;

export const StyledAntdMenu = styled(Menu)`
  width: 100%;
`;

export const UserMenuContainer = styled.div`
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 4rem;
`;
